import { model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

export class TutorialUserStats extends Model({
  // This field is used in courses and is not needed for standalone tutorials for now
  // We get it when requesting all lessons of a course
  isWatched: types.maybeNull(types.boolean),
  isLiked: types.boolean,
  isSaved: types.boolean,
}) {
  markAsWatched() {
    this.isWatched = true;
  }

  toggleIsSaved() {
    this.isSaved = !this.isSaved;
  }

  toggleIsLiked() {
    this.isLiked = !this.isLiked;
  }
}

export const TutorialUserStatsModel = model(TutorialUserStats);
